import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Tooltip from "@material-ui/core/Tooltip";
import CvcIcon from 'web/assets/images/cvc.png';
import * as moment from 'moment';
import { showAppLoader, hideAppLoader } from 'redux/actions/app';

import {
  useStripe,
  useElements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js';
import { KEY } from 'web/components/utils/stripeKey';

import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import { setupIntentGet } from 'redux/actions/register';
import { paymentMethodCreate, subscriptionsCreate, subscriptionsAddNew, paymentMethodProfileCreate, profileCreateBuyerSeller } from 'redux/actions/payment';
import { CardTypeSectionStripe } from 'web/pages/private/CommonPages/ManageAccount/AddCardPopup/Credit-Card/debit-form/debit-Form-Styled';
import styles from './debitForm.module.scss';

const useOptions = () => {
  const fontSize = '16px';
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [fontSize]
  );

  return options;
};

const DebitForm = ({ pageData, modalType, taxLicenseOptions, props, callBackFetchApi, callBack, pageLanguageContents }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const token = localStorage.getItem('token');
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [cardName, setCardName] = useState('');
  const [alertType, setAlertType] = useState();
  const toggleModal = () => setModal(!modal);
  let title = '';

  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();

  let cardBrandToPfClass = {
    visa: 'pf-visa',
    mastercard: 'pf-mastercard',
    amex: 'pf-american-express',
    discover: 'pf-discover',
    diners: 'pf-diners',
    jcb: 'pf-jcb',
    unknown: 'pf-credit-card',
  };

  let taxId = localStorage.getItem('taxId')
  let drivingLicense = localStorage.getItem('drivingLicense');

  let companyName = localStorage.getItem('companyName')
  if (!companyName) {
    companyName = ''
  }

  let firstName = localStorage.getItem('firstName');
  let lastName = localStorage.getItem('lastName');
  let dob = localStorage.getItem('dob')
  let uploadImage = localStorage.getItem('uploadImage')

  const setBrandIcon = (brand) => {
    let brandIconElement = document.getElementById('brand-icon0');
    let pfClass = 'pf-credit-card';
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    if (!cardName) {
      setModalContent("Please enter name on the card first.");
      setModalLink('');
      toggleModal();
    } else {
      callSubmit()
    }
  };
  const stripeResponseHandler = (status, response) => {
  }
  const callSubmit = async () => {
    if (props) {
      const { setTouched } = props
      setTouched({});
    }

    // profile type conversion from seller to both buyer and seller
    if (modalType === 'sellerToBothBuySellConversion') {
      dispatch(showAppLoader())
      addAccount(props, '')
    } else if (modalType === 'buyerToBothBuySellConversion' || modalType === 'sellerRemittanceDetailsAdd') {
      if (taxLicenseOptions) {
        if (props.values.taxIdType === '1') {
          if (!props.values.taxId) {
            setModalContent('Tax Id is required.')
            setModalLink('');
            toggleModal();
            return
          } else {
            paymentFunctionWithTaxId(props)
          }
        } else if (props.values.taxIdType === '2') {
          if (!props.values.drivingLicense) {
            setModalContent('Driving license is required.')
            setModalLink('');
            toggleModal();
            return
          }
          else if (!props.values.firstName) {
            setModalContent('First name is required.')
            setModalLink('');
            toggleModal();
            return
          }
          else if (!props.values.lastName) {
            setModalContent('Last name is required.')
            setModalLink('');
            toggleModal();
            return
          }
          else if (!props.values.drivingLicenseDoc) {
            setModalContent("Please upload driver's license first.");
            setModalLink('');
            toggleModal();
            return
          } else if (!(moment().diff(moment(props.values.dob), 'years') >= 18)) {
            setModalContent('You are not under 18 years of age.')
            setModalLink('');
            toggleModal();
            return
          } else {
            paymentFunctionWithLicense(props)
          }
        } else {
          if (pageData?.userDetails?.license && pageData?.userDetails?.license !== '') {
            paymentFunctionWithLicense(props)
          } else if (pageData?.userDetails?.tax && pageData?.userDetails?.tax !== '') {
            paymentFunctionWithTaxId(props)
          }
        }
      } else {
        addAccount(props, '')
      }
    } else {
      dispatch(showAppLoader())
      addAccount(props, '')
    }
  }

  const paymentFunctionWithTaxId = async (props) => {
    let businessType = "company"
    const result = await stripe.createToken('account', {
      business_type: businessType,
      company: {
        tax_id: props.values.taxIdType === '1' ? props.values.taxId : pageData?.userDetails?.tax,
        name: pageData?.userDetails?.companyName,
        address: {
          line1: `${pageData?.userDetails?.address?.address1} ${pageData?.userDetails?.address?.address2 ? pageData?.userDetails?.address?.address2 : ''}`,
          city: pageData?.userDetails?.address?.city,
          state: pageData?.userDetails?.address?.state,
          postal_code: pageData?.userDetails?.address?.zipCode,
        },
      },
      tos_shown_and_accepted: true,
    }).then(function (result) {
      if (result.token) {
        addAccount(props, result.token.id)
      }
      if (result.error) {
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    });
  }

  const paymentFunctionWithLicense = async (props) => {
    let businessType = 'individual'

    dispatch(showAppLoader())
    const data = new FormData();
    data.append('file', props.values?.drivingLicenseDocForStripe);
    data.append('purpose', 'identity_document');
    const fileResult = await fetch('https://uploads.stripe.com/v1/files', {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${KEY}` },
      body: data,
    });
    const fileData = await fileResult.json();

    let dayMonthYear = props.values.taxIdType === '0' ? pageData?.userDetails?.dob?.split('-') : props.values.dob.split('-')
    const result = await stripe.createToken('account', {
      business_type: businessType,
      individual: {
        first_name: props.values.taxIdType === '0' ? pageData?.userDetails?.firstName : props.values.firstName,
        last_name: props.values.taxIdType === '0' ? pageData?.userDetails?.lastName : props.values.lastName,
        address: {
          line1: `${pageData?.userDetails?.address?.address1} ${pageData?.userDetails?.address?.address2 ? pageData?.userDetails?.address?.address2 : ''}`,
          city: pageData?.userDetails?.address?.city,
          state: pageData?.userDetails?.address?.state,
          postal_code: pageData?.userDetails?.address?.zipCode,
        },
        email: pageData?.userDetails?.emailId,
        dob: {
          day: dayMonthYear[2],
          month: dayMonthYear[1],
          year: dayMonthYear[0]
        },
        ssn_last_4: '1234',
        verification: {
          document: {
            front: fileData.id
          },
        },
      },
      tos_shown_and_accepted: true,
    }).then(function (result) {
      dispatch(hideAppLoader())
      if (result.token) {
        addAccount(props, result.token.id)
      }
      if (result.error) {
        setModalContent(result.error.message)
        setModalLink('');
        toggleModal();
        return false
      }
    });
  }

  const addAccount = async (props, accountToken) => {
    const card = elements.getElement(CardNumberElement);
    const result = await stripe.createToken(card, {
      currency: 'usd',
      name: cardName,
    }, stripeResponseHandler);
    let response;
    if (result.token) {
      if (modalType === 'sellerToBothBuySellConversion') {
        dispatch(hideAppLoader());
        if (result.token.card.funding !== "debit" && result.token.card.funding !== "credit") {
          setModalContent("Card details not validated")
          setModalLink('');
          toggleModal();
        } else {
          callProfileApI()
        }
      } else if (modalType === 'buyerToBothBuySellConversion') {
        dispatch(hideAppLoader());
        if (result.token.card.funding !== "debit") {
          setModalContent("Debit card details are invalid.")
          setModalLink('');
          toggleModal();
        } else {
          let data = {
            forSelling: true,
            token: result.token.id,
            name: cardName,
            forReseller: true,
            accountToken: accountToken,
            drivingLicense: drivingLicense && props.values.taxIdType === '0' ? drivingLicense : props.values.drivingLicense,
            uploadImage: drivingLicense && uploadImage ? uploadImage : props.values.drivingLicenseDoc,
            dob: drivingLicense && props.values.taxIdType === '0' ? dob : props.values.taxIdType === '2' ? props.values.dob : '',
            taxId: props.values.taxIdType === '1' ? props.values.taxId : taxId
          }
          response = await dispatch(profileCreateBuyerSeller(data, token));
        }
      } else if (modalType === 'sellerRemittanceDetailsAdd') {
        // if this is independent acc and adding seller payment for the first time 'paymentMethod/independent/create' api is used
        // else 'paymentMethod/create' is used
        // if 'accountToken' exists, means it is a new seller payment addition
        if (result.token.card.funding !== "debit") {
          setModalContent("Debit card details are invalid.")
          setModalLink('');
          toggleModal();
          return
        }
        if (accountToken && accountToken !== '') {
          let data = {
            forSelling: true,
            token: result.token.id,
            name: cardName,
            forReseller: true,
            accountToken: accountToken,
            drivingLicense: props.values.taxIdType === '0' ? pageData?.userDetails?.license : props.values.drivingLicense,
            uploadImage: props.values.taxIdType === '0' ? pageData?.userDetails?.uploadImage : props.values.drivingLicenseDoc,
            dob: props.values.taxIdType === '0' ? pageData?.userDetails?.dob : props.values.taxIdType === '2' ? props.values.dob : '',
            taxId: props.values.taxIdType === '1' ? props.values.taxId : pageData?.userDetails?.tax
          }
          response = await dispatch(paymentMethodProfileCreate(data, token));
        } else {
          let data = {
            forSelling: true,
            forReseller: true,
            token: result.token.id,
            name: cardName,
          }
          response = await dispatch(paymentMethodCreate(data, token));
        }
      } else if (modalType === 'buyerPaymentDetailsAdd' || modalType === 'newSubscriptionAdd') {
        const getResponse = await dispatch(setupIntentGet(token));
        if (getResponse.status === "SUCCESS") {
          let client_secret = getResponse.payload
          const payload = await stripe
            .confirmCardSetup(client_secret, {
              payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                  name: cardName,
                },
              },
            })
            .then(function (result) {
              if (result.error) {
                dispatch(hideAppLoader());
                setModalContent(result.error.message);
                setModalLink('');
                toggleModal();
              } else {
                paymentMethodCreateFun(result)
              }
            });
        } else {
          setModalContent(getResponse.message);
          setModalLink('');
          toggleModal();
        }
      }
      if (response) {
        if (response.status === "SUCCESS") {
          setAlertType('cardValidated')
          setModalContent("Card details added successfully.");
          setModalLink('');
          toggleModal();
        } else {
          if (response.statusCode === 401) {
            history.push('/sign-in');
            window.location.reload(false);
          } else {
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
          }
        }
      }
    } else if (result.error) {
      dispatch(hideAppLoader());
      setModalContent(result.error?.message || 'Something went wrong, please try again.');
      setModalLink('');
      toggleModal();
    } else {
      dispatch(hideAppLoader());
    }
  }

  const paymentMethodCreateFun = async (result) => {
    let response;
    let data = {
      forBuying: true,
      paymentMethodId: result.setupIntent.payment_method,
      name: cardName
    }
    if (modalType === 'newSubscriptionAdd') response = await dispatch(subscriptionsAddNew(data, token))
    else if (modalType === 'buyerPaymentDetailsAdd') {
      // if this is independent acc and adding buyer payment for the first time 'paymentMethod/independent/create' api is used
      // else 'paymentMethod/create' is used
      if (pageData?.userDetails?.locationType === 'INDEPENDENT' &&
        (!pageData?.buyerPaymentDetails?.achDetails || pageData?.buyerPaymentDetails?.achDetails?.length === 0) &&
        (!pageData?.buyerPaymentDetails?.cardDetails || pageData?.buyerPaymentDetails?.cardDetails?.length === 0)) {
        response = await dispatch(paymentMethodProfileCreate(data, token));
      } else {
        response = await dispatch(paymentMethodCreate(data, token));
      }
    }
    if (response?.status === "SUCCESS") {
      setAlertType('cardValidated')
      setModalContent("Card details added successfully.");
      setModalLink('');
      toggleModal();
    }
    else {
      if (response.statusCode === 401) {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  const callProfileApI = async () => {
    const getResponse = await dispatch(setupIntentGet(token));
    if (getResponse.status === "SUCCESS") {
      let client_secret = getResponse.payload
      const payload = await stripe
        .confirmCardSetup(client_secret, {
          payment_method: {
            card: elements.getElement(CardNumberElement),
            billing_details: {
              name: cardName,
            },
          },
        })
        .then(function (result) {
          if (result.error) {
            dispatch(hideAppLoader());
            setModalContent(result.error.message);
            setModalLink('');
            toggleModal();
          } else {
            profileUpdate(result)
          }
        });
    } else {
      if (getResponse.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(getResponse.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  const profileUpdate = async (result) => {
    let data = {
      forBuying: true,
      paymentMethodId: result.setupIntent.payment_method,
      name: cardName,
      forReseller: true,
    }
    let response = await dispatch(profileCreateBuyerSeller(data, token));
    if (response.status === "SUCCESS") {
      setAlertType('buyerCardValidated')
      setModalContent("Card details added successfully.");
      setModalLink('');
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in');
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  return (
    <div className='paymentWrapper '>
      {loaderVisible && <Spinner />}
      <div className='payment'>
        <div>
          <CardTypeSectionStripe>
            <form onSubmit={handleSubmit}>
              <label>
                {pageLanguageContents?.Arrow_Payment[18]?.SubName || 'Name on the Card'}
                <input
                  name='cardName'
                  className='stripeInput'
                  placeholder={pageLanguageContents?.Arrow_Payment[18]?.SubName}
                  value={cardName}
                  // onChange={(event) => {
                  //   const setValue = event.target.value.replace(/[^a-zA-Z\s&.,-]/g, '')
                  //   let firstLetterCap = setValue.charAt(0).toUpperCase() + setValue.slice(1)
                  //   setCardName(firstLetterCap);
                  // }}
                  onChange={(event) => {
                    const setValue = event.target.value;
                    const sanitizedValue = setValue.replace(/[^A-Za-z0-9&,.\- ]/g, ''); // Allow letters, numbers, &, , . - and spaces
                    const containsLettersOrNumbers = /[A-Za-z0-9]/.test(sanitizedValue);

                    if (containsLettersOrNumbers) {
                      // Capitalize the first letter of each word
                      const words = sanitizedValue.split(/\s+/);
                      const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
                      const formattedValue = capitalizedWords.join(' ');
                      setCardName(formattedValue)
                    } else {
                      // If the input does not contain letters, set an empty string in the form field or display an error message
                      setCardName("")
                    }
                  }}
                />
              </label>
              <label>
                {pageLanguageContents?.Arrow_Payment[19]?.SubNumber}
                <CardNumberElement
                  options={options}
                  onReady={() => {
                  }}
                  onChange={(event) => {
                    // Switch brand logo
                    if (event.brand) {
                      setBrandIcon(event.brand);
                    }

                  }}
                  onBlur={() => {
                  }}
                  onFocus={() => {
                  }}
                />
                <span class="brand">
                  <i id={"brand-icon0"}></i>
                </span>
              </label>

              <label>
                {pageLanguageContents?.Arrow_Payment[20]?.SubDate}
                <CardExpiryElement
                  options={options}
                  onReady={() => {
                  }}
                  onChange={(event) => {
                  }}
                  onBlur={() => {
                  }}
                  onFocus={() => {
                  }}
                />
              </label>
              <label>
                {pageLanguageContents?.Arrow_Payment[21]?.SubCVV}
                <CardCvcElement
                  options={options}
                  onReady={() => {
                  }}
                  onChange={(event) => {
                  }}
                  onBlur={() => {
                  }}
                  onFocus={() => {
                  }}
                />

                <Tooltip
                  placement="top"
                  arrow
                  title={<img src={CvcIcon} alt="icon" />}
                  enterTouchDelay={0}
                >
                  <span className="i-icon">i</span>
                </Tooltip>
              </label>
              <div className={styles.footer}>
                <div className={styles.fieldGroup}>

                  <div className={styles.field}>
                    <button
                      type='submit'
                      className='app-green-button'
                      disabled={!stripe}>
                      {pageLanguageContents?.Arrow_Payment[22]?.Submit}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </CardTypeSectionStripe>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            alertType={alertType}
            callBackAlert={(val) => {
              if (val === 'cardValidated') {
                callBackFetchApi()
                callBack()
                setModal(!modal)
              }
              if (val === "buyerCardValidated") {
                callBackFetchApi()
                callBack()
              }
            }}
            content={modalContent}
            link={modalLink}
          />
        </div>
      </div>
    </div>
  );
};

export default DebitForm;